/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Bound by enum name rather than by the display name the column holds.
 * @export
 * @enum {string}
 */
export enum LicenseType {
    ALL = 'ALL',
    SYSTEM = 'SYSTEM',
    ADMIN = 'ADMIN',
    POWER = 'POWER',
    LITE = 'LITE'
}



